export const newscard = [
   {
      image: "https://parceirando.s3.amazonaws.com/media/landing/2.webp",
      title: "Manual",
      description: "Minisite, o que é? pra que serve?",
      url: "https://afiliado.parceirando.com.br/material-de-apoio#h.ndtuj1ca77j0"
   },
   {
      image: "https://parceirando.s3.amazonaws.com/media/landing/1.webp",
      title: "Manual",
      description: "Resgatar seu link de afiliado.",
      url: "https://afiliado.parceirando.com.br/material-de-apoio#h.99zsp1jtsewv"
   },
   {
      image: "https://parceirando.s3.amazonaws.com/media/landing/4.webp",
      title: "Manual",
      description: "Manual do Afiliado",
      url: "https://afiliado.parceirando.com.br/material-de-apoio"
   },
   {
      image: "https://parceirando.s3.amazonaws.com/media/landing/3.webp",
      title: "Novidades",
      description: "Canal exclusivo para afiliados.",
      url: "https://app.getbeamer.com/parceirandoafiliados/en"
   }
]